import {isNil} from 'ramda';

import {FinancingCompositionScene} from '@dms/api/shared';

const FALLBACK_SCALE = 0.5;
const MAX_SCALE = 1;

/**
 * View scale that fits the whole canvas into the available area without upscaling. Returns a
 * fallback before the area has been measured so the first paint already has a sensible size.
 */
export const getCanvasViewScale = (
  canvas: Pick<FinancingCompositionScene['canvas'], 'width' | 'height'>,
  availableWidth: number | null,
  availableHeight: number | null
) => {
  if (
    isNil(availableWidth) ||
    isNil(availableHeight) ||
    availableWidth <= 0 ||
    availableHeight <= 0
  ) {
    return FALLBACK_SCALE;
  }
  return Math.min(availableWidth / canvas.width, availableHeight / canvas.height, MAX_SCALE);
};
